import dynamic from 'next/dynamic';
import React, { FunctionComponent } from 'react';
import { Box } from '@wix/design-system';
import classNames from 'classnames';
import { DATA_HOOKS } from '../../dataHooks';
const LoaderVideo = dynamic(() => import('./LoaderVideo'), { ssr: false });
import css from './index.module.scss';

const Loader: FunctionComponent = () => (
  <Box
    className={classNames(css.wrapper)}
    dataHook={DATA_HOOKS.HC_LOADER}
    align='center'
    verticalAlign='middle'
    direction='vertical'
  >
    <LoaderVideo />
  </Box>
);

export default Loader;
